export default __webpack_public_path__ + "static/media/iq.5cd51d2b.svg";